import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Paper, AppBar, Toolbar, Divider } from '@mui/material';
import { fetchCompanyInfo } from '../services/companyInfo';

function PrivacyPage() {
  const [company, setCompany] = useState({ company_name: '', company_phone: '', company_address: '' });
  useEffect(() => { fetchCompanyInfo().then(setCompany).catch(() => {}); }, []);
  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#1976d2' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {company.company_name || ''}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={1} sx={{ p: { xs: 3, md: 5 } }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
            개인정보처리방침
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 4 }}>
            시행일: 2026년 2월 10일
          </Typography>

          <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 4 }}>
            {company.company_name || ''}(이하 "회사")는 개인정보보호법, 위치정보의 보호 및 이용 등에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보처리방침을 수립·공개합니다.
          </Typography>

          <Section title="제1조 (개인정보의 처리 목적)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행합니다.
            </Typography>
            <NumberedList items={[
              '회원가입 및 관리: 회원제 서비스 제공에 따른 본인인증, 회원 자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지',
              '서비스 제공: 화물 운송 배차 매칭, 배송 현황 관리, 운송료 정산',
              '위치정보 서비스: 실시간 위치 확인을 통한 배차 서비스 제공, 최적 경로 안내',
              '고충 처리: 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리 결과 통보',
              '마케팅 및 광고: 신규 서비스 안내, 이벤트 및 광고성 정보 제공 (선택 동의 시)',
            ]} />
          </Section>

          <Section title="제2조 (처리하는 개인정보 항목)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 다음의 개인정보 항목을 처리하고 있습니다.
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>1. 필수항목</Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <ListItem>본인인증 정보: 성명, 생년월일, 휴대전화번호, CI/DI (본인확인값)</ListItem>
              <ListItem>운전자 정보: 차량번호, 차종, 적재중량</ListItem>
              <ListItem>사업자 정보: 사업자등록번호, 주소</ListItem>
              <ListItem>보험 정보: 보험회사명, 보험 만기일</ListItem>
              <ListItem>계정 정보: PIN(비밀번호)</ListItem>
            </Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>2. 선택항목</Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <ListItem>정산 정보: 은행명, 계좌번호</ListItem>
              <ListItem>기타: 특이사항, 주민등록번호 (본인확인 목적)</ListItem>
            </Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>3. 자동수집항목</Typography>
            <Box component="ul" sx={{ pl: 3 }}>
              <ListItem>위치정보(GPS 좌표), 앱 사용기록, 접속 로그, 접속 IP, 기기정보(OS, 디바이스 모델), 푸시 토큰</ListItem>
            </Box>
          </Section>

          <Section title="제3조 (개인정보의 처리 및 보유기간)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 동의 받은 기간 내에서 개인정보를 처리·보유합니다.
            </Typography>
            <NumberedList items={[
              '회원 정보: 회원 탈퇴 시까지 (탈퇴 후 30일 이내 파기)',
              '위치정보: 수집일로부터 6개월',
              '거래 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)',
              '계약 또는 청약 철회에 관한 기록: 5년 (전자상거래법)',
              '대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)',
              '소비자 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래법)',
              '접속 로그 기록: 3개월 이상 (통신비밀보호법)',
            ]} />
          </Section>

          <Section title="제4조 (개인정보의 제3자 제공)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 다음의 경우에만 개인정보를 제3자에게 제공합니다.
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>1. 배차 의뢰 업체 (화주)</Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <ListItem>제공 항목: 운전자 성명, 연락처, 차량번호, 차종, 보험 정보</ListItem>
              <ListItem>제공 목적: 화물 운송 서비스 이행</ListItem>
              <ListItem>보유 기간: 운송 완료 후 1년</ListItem>
            </Box>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              2. 법령에 의거하거나, 수사기관의 요청이 있는 경우
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              3. 정보주체의 별도 동의가 있는 경우
            </Typography>
          </Section>

          <Section title="제5조 (개인정보처리의 위탁)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>1. 클라우드 서비스 (Amazon Web Services)</Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <ListItem>위탁 업무: 서버 운영, 데이터 보관</ListItem>
              <ListItem>보유 기간: 위탁 계약 종료 시까지</ListItem>
            </Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>2. 다날(DANAL)</Typography>
            <Box component="ul" sx={{ pl: 3 }}>
              <ListItem>위탁 업무: 본인인증 서비스</ListItem>
              <ListItem>보유 기간: 인증 완료 후 즉시 파기</ListItem>
            </Box>
          </Section>

          <Section title="제6조 (정보주체의 권리·의무 및 행사방법)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
            </Typography>
            <NumberedList items={[
              '개인정보 열람 요구',
              '개인정보에 오류가 있을 경우 정정 요구',
              '개인정보 삭제 요구',
              '개인정보 처리정지 요구',
            ]} />
            <Box sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
                ※ 권리 행사는 서면, 전화, 이메일을 통해 가능하며, 회사는 이에 대해 지체 없이 조치하겠습니다.<br />
                ※ 정보주체가 개인정보 정정 및 삭제를 요구한 경우 회사는 완료할 때까지 해당 개인정보를 이용하거나 제공하지 않습니다.<br />
                ※ 만 14세 미만 아동의 개인정보는 수집하지 않습니다.
              </Typography>
            </Box>
          </Section>

          <Section title="제7조 (위치정보의 처리)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 위치정보의 보호 및 이용 등에 관한 법률에 따라 다음과 같이 위치정보를 처리합니다.
            </Typography>
            <NumberedList items={[
              '수집 목적: 실시간 배차 매칭, 최적 경로 안내, 배송 현황 추적 제공',
              '수집 방법: GPS를 통한 자동 수집 (앱 사용 중 백그라운드 포함)',
              '이용 기간: 서비스 이용 중 실시간 수집, 수집일로부터 6개월 보관 후 파기',
              '제3자 제공: 배차 의뢰 업체(화주) 및 관리자에게 실시간 위치 제공',
              '거부 권리: 위치정보 수집에 동의하지 않을 수 있으나, 이 경우 배차 서비스 이용이 제한됩니다.',
              '위치정보 관련 분쟁 시 위치정보사업자 또는 방송통신위원회에 구제를 신청할 수 있습니다.',
            ]} />
          </Section>

          <Section title="제8조 (개인정보의 파기절차 및 방법)">
            <NumberedList items={[
              '파기 절차: 보유 기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.',
              <>파기 방법
                <Box component="ul" sx={{ pl: 3, mt: 0.5 }}>
                  <ListItem>전자적 파일: 복원이 불가능한 방법으로 영구 삭제</ListItem>
                  <ListItem>종이 문서: 분쇄기로 분쇄하거나 소각</ListItem>
                </Box>
              </>,
            ]} />
          </Section>

          <Section title="제9조 (개인정보의 안전성 확보조치)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
            </Typography>
            <NumberedList items={[
              '관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육, 개인정보 접근 권한 최소화',
              '기술적 조치: 개인정보처리시스템 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화(SSL/TLS), 보안프로그램 설치 및 갱신',
              '물리적 조치: 전산실 및 자료보관실 접근 통제',
            ]} />
          </Section>

          <Section title="제10조 (개인정보 자동 수집 장치의 설치·운영 및 거부)">
            <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 기술을 사용합니다. 이용자는 앱 설정을 통해 관련 정보의 저장을 거부할 수 있으나, 이 경우 서비스 이용에 어려움이 발생할 수 있습니다.
            </Typography>
          </Section>

          <Section title="제11조 (개인정보 보호책임자)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
            </Typography>
            <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>개인정보 보호책임자</Typography>
              <Typography variant="body1">회사명: {company.company_name || ''}</Typography>
              {company.company_phone && <Typography variant="body1">대표전화: {company.company_phone}</Typography>}
              {company.company_address && <Typography variant="body1">주소: {company.company_address}</Typography>}
            </Box>
          </Section>

          <Section title="제12조 (권익침해 구제방법)">
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              정보주체는 개인정보침해로 인한 구제를 받기 위하여 다음 기관에 분쟁해결이나 상담 등을 신청할 수 있습니다.
            </Typography>
            <Box component="ul" sx={{ pl: 3 }}>
              <ListItem>개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)</ListItem>
              <ListItem>개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)</ListItem>
              <ListItem>대검찰청 사이버수사과: (국번없이) 1301 (www.spo.go.kr)</ListItem>
              <ListItem>경찰청 사이버수사국: (국번없이) 182 (ecrm.cyber.go.kr)</ListItem>
            </Box>
          </Section>

          <Section title="제13조 (개인정보처리방침의 변경)">
            <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              이 개인정보처리방침은 2026년 2월 10일부터 적용됩니다. 변경 사항이 있는 경우 시행일 7일 전부터 앱 내 공지사항을 통하여 고지할 것입니다.
            </Typography>
          </Section>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ textAlign: 'center', color: 'text.secondary' }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{company.company_name || ''}</Typography>
            {company.company_phone && <Typography variant="body2">대표전화: {company.company_phone}</Typography>}
            {company.company_address && <Typography variant="body2">주소: {company.company_address}</Typography>}
          </Box>
        </Paper>
      </Container>
    </>
  );
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1.5, color: '#1976d2' }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function NumberedList({ items }) {
  return (
    <Box component="ol" sx={{ pl: 3, m: 0 }}>
      {items.map((item, index) => (
        <Box component="li" key={index} sx={{ mb: 1 }}>
          <Typography variant="body1" component="div" sx={{ lineHeight: 1.8 }}>
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

function ListItem({ children }) {
  return (
    <Box component="li" sx={{ mb: 0.5 }}>
      <Typography variant="body1" sx={{ lineHeight: 1.8 }}>{children}</Typography>
    </Box>
  );
}

export default PrivacyPage;
